export default {
    deleteFarmH: "Apakah Anda yakin ingin menghapus pertanian ini?",
    maxLimit: "Batas maksimum tidak boleh lebih dari enam digit.",
    emptyDeforestationStatus: "Status deforestasi EUDR kosong.",
    deleteFarmMsg:
      "Harap berikan konfirmasi tambahan, karena menghapus pertanian ini akan menghapus semua informasi terkait dengan pertanian, seperti tanaman, laporan, dll.",
    "Avg Area in Hectares": "Rata-rata Area dalam Hektar",
    "Avg Area in Acres": "Rata-rata Area dalam Acre",
    "Avg Area in Manzana": "Rata-rata Area dalam Manzana",
    used: "Digunakan",
    january: "Januari",
    february: "Februari",
    march: "Maret",
    april: "April",
    may: "Mei",
    june: "Juni",
    july: "Juli",
    august: "Agustus",
    september: "September",
    october: "Oktober",
    november: "November",
    december: "Desember",
    warning: "Peringatan",
  
    meter: "Meter",
    kiloMeter: "Kilometer",
    gram: "Gram",
    kilogram: "Kilogram",
    pound: "Pound",
    cubicKilo: "Kilometer Kubik (km³)",
    cubicMeter: "Meter Kubik (m³)",
    cubicCentimeter: "Sentimeter Kubik (cm³)",
    cubicMilimeter: "Milimeter Kubik (mm³)",
    goBack: "Kembali",
    selectFileToUpload: "Pilih file untuk mengunggah data",
    totalRecords: "Total catatan",
    success: "Berhasil",
    recordsImported: "Catatan diimpor",
    psw: "Kata sandi",
    topFive: "Lima Teratas",
    deleted: "Dihapus dengan berhasil",
    failed: "Gagal",
    fermentation: "Fermentasi",
    confPsw: "Konfirmasi Kata Sandi",
    newPsw: "Kata Sandi Baru",
    email: "Email",
    emailId: "ID Email",
    submit: "Kirim",
    cancel: "Batal",
    faqs: "FAQ",
    id: "ID",
    processor: "Processor",
    cuppingScore: "Skor Cupping",
    label: "Label",
    expiry: "Kadaluarsa",
    users: "Pengguna",
    language: "Bahasa",
    appUser: "Pengguna Aplikasi",
    app_users: "Pengguna Aplikasi",
    offline_users: "Pengguna Offline",
    dimitraAdmin: "Admin Dimitra",
    admin_users: "Pengguna Admin",
    search: "Cari",
    searchByProducerName: "Cari berdasarkan nama produsen",
    searchBy: "Cari {type}",
    firstName: "Nama Depan",
    lastName: "Nama Belakang",
    mobile: "Nomor HP",
    mobileNumber: "Nomor HP",
    department: "Departemen",
    departmentName: "Nama Departemen",
    role: "Peran",
    status: "Status",
    permission: "Izin",
    activity_log: "Log Aktivitas",
    profile_auth: "Otentikasi Profil",
    countryCode: "Kode Negara",
    selectDept: "Pilih Departemen",
    selectRole: "Pilih Peran",
    edit: "Ubah",
    update: "Perbarui",
    delete: "Hapus",
    view: "Lihat",
    deactivate: "Nonaktifkan",
    activate: "Aktifkan",
    serverError: "Ada masalah. Silakan coba lagi nanti.",
    minute: "Menit",
    perHour: "Per jam",
    day: "Hari",
    enterDescription: "Masukkan deskripsi Anda di sini",
    enterHere: "Masukkan di sini",
    enterMobile: "Masukkan nomor HP",
    phoneRequired: "Nomor HP diperlukan",
    phoneValid: "Nomor HP harus valid",
    unableToUpdate: "Tidak dapat memperbarui",
    membershipPlans: "Rencana Keanggotaan",
    byWeek: "Per Minggu",
    byMonth: "Per Bulan",
    byYear: "Per Tahun",
    custom: "Kustom",
    name: "Nama",
    warehouse: "Gudang",
    regionState: "Region/Provinsi",
    provinceState: "Provinsi",
    cityTown: "Desa/Kota",
    membershipValidity: "Validitas Keanggotaan Dasar",
    basicPlanValidity: "Validitas Rencana Dasar",
    membershipExpiryDate: "Tanggal Kedaluwarsa Keanggotaan",
    extendedValidity: "Validitas Diperpanjang",
    exportAsCSV: "Ekspor sebagai CSV",
    filterBy: "Filter Berdasarkan",
    autoCondition: "Kondisi Otomatis",
    conditional: "Kondisional",
    comingSoon: "Segera Hadir",
    userRole: "Peran Pengguna",
    addUserRole: "Tambah Peran Pengguna",
    editUserRole: "Ubah Peran Pengguna",
    additionalInformationRequired: "Informasi Tambahan Diperlukan",
    back: "Kembali",
    browse: "Telusuri",
    clearAll: "BERSIHKAN SEMUA",
    filterByRegion: "Filter Berdasarkan Region",
    continue: "Lanjutkan",
    description: "Deskripsi",
    selectWeek: "Pilih Minggu",
    hideSplash: "Sembunyikan Layar Awal?",
    hideLogo: "Sembunyikan Logo?",
    confirm: "KONFIRMASI",
    selectMonth: "Pilih Bulan",
    selectDateRange: "Pilih Rentang Tanggal",
    regionDistrict: "Region/Distrik",
    address: "Alamat",
    familyTribe: "Suku Keluarga",
    website: "Situs Web",
    deactivated: "Nonaktif",
    active: "Aktif",
    inactive: "Tidak Aktif",
    country: "Negara",
    state: "Provinsi",
    farmer: "Petani",
    commodity: "Komoditas",
    quantity: "Kuantitas",
    unit: "Unit",
    price: "Harga",
    save: "SIMPAN",
    remove: "Hapus",
    stateIsReq: "Provinsi diperlukan",
    cityIsReq: "Kota diperlukan",
    addressIsReq: "Alamat diperlukan",
    membershipTypeReq: "Jenis keanggotaan diperlukan",
    extendedReasonReq: "Alasan perpanjangan diperlukan",
    numberOfDaysReq: "Jumlah hari diperlukan",
    extendedMembershipValidity: "Validitas Keanggotaan Diperpanjang",
    set: "SET",
    adminRole: "Peran Admin",
    typeMsg: "Ketik pesan Anda di sini",
    mile: "Mil",
    manageFarmer: "Kelola Petani",
    manageOfflineFarmers: "Kelola Petani Offline",
    dashboardSettings: "Pengaturan Dasbor",
    done: "Selesai",
    noRecordFound: "Tidak ada catatan ditemukan",
    farmerName: "Nama Petani",
    production: "Produksi",
    registered: "Terdaftar",
    downloadForReport: "UNDUH LAPORAN PDF",
    downloadPdfReport: "Unduh Laporan PDF",
    notifications: "Notifikasi",
    markAllAsRead: "Tandai Semua Sebagai Sudah Dibaca",
    viewNotifications: "Lihat Notifikasi",
    youAreUpToDate: "Anda sudah terbaru",
    sendNotifications: "Kirim Notifikasi",
    createNotification: "Buat Notifikasi",
    viewAllNotifications: "Lihat semua Notifikasi",
    createNotificationForGroup: "Buat Notifikasi untuk Grup/Pengguna Ganda",
    createNotificationForDimitra: "Buat Notifikasi untuk Admin Dimitra",
    pleaseCheckTickMark:
      "Silakan centang tanda centang untuk menambahkan pengguna dalam daftar",
    clearAllFilters: "Hapus Semua Filter",
    note: "*Catatan: Hanya file Mp4 yang didukung untuk video",
    validMemberships: "Keanggotaan yang Valid",
    memberShipPlanMessage:
      "Apakah Anda yakin ingin menghapus rencana keanggotaan ini?",
    deleteMemberShipPlan: "Hapus Rencana Keanggotaan",
    systemAutoLogout: "Sistem akan logout otomatis dalam 2 menit",
    monday: "Senin",
    tuesday: "Selasa",
    Wednesday: "Rabu",
    thursday: "Kamis",
    friday: "Jumat",
    saturday: "Sabtu",
    sunday: "Minggu",
    addnewOfflineFarmer: "Tambah petani offline baru",
    export: "Ekspor",
    exportAs: "Ekspor sebagai",
    createNewOfflineFarmer: "Buat Petani Offline Baru",
    offlineFarmerForByingStationOnly:
      "Petani Offline hanya untuk stasiun pembelian (Lokal)",
    offlineFarmerForAllByingStations:
      "Petani offline untuk semua stasiun pembelian (Global)",
    noDataAvailable: "Tidak ada data yang tersedia",
    buyingStation: "Stasiun Pembelian",
    dryMillingStation: "Stasiun Penggilingan Kering",
    mergeWithExistingAccount: "Gabungkan dengan akun yang sudah ada",
    createNewAccount: "Buat akun baru",
    mobileOrEmailRequiredForRegister:
      "Untuk mendaftar aplikasi, setidaknya satu detail harus disediakan, baik nomor HP atau email.",
    selectLanguage: "Pilih bahasa",
    basicPlan: "Rencana Dasar",
    local: "Lokal",
    newUser: "Pengguna Baru",
    merged: "Digabungkan",
    global: "Global",
    qrcode: "Kode QR",
    emailSentSuccessfully: "Email berhasil dikirim",
    somethingWentWrong: "Ada yang salah",
    farms: "Peternakan",
    farmers: "Petani",
    large: "Besar",
    medium: "Sedang",
    small: "Kecil",
    step: "Langkah",
    fileError: "Kesalahan File",
    ProvideFileFormat: "Catatan Penting: Harap berikan format berikut (PNG/JPEG)",
    signHere: "Tanda di sini",
    numOfDaysRemaining: "Jumlah Hariyang Tersisa",
    requesterNameIsRequired: "Nama Peminta diperlukan",
    messageIsRequired: "Pesan diperlukan",
    emailIsInvalid: "Email tidak valid",
    emailIsRequired: "Email diperlukan",
    read: "Baca",
    unread: "Belum Dibaca",
    all: "Semua",
    filesSucessfullyUploaded: "File berhasil diunggah",
  
    unsynced_record: "Rekaman yang Belum Disinkronkan",
  
    loadingData: "Memuat Data...",
    markAsRead: "Tandai Sebagai Sudah Dibaca",
  
    of: "dari",
    ok: "OK",
  
    orderBy: "Urutkan Berdasarkan",
    select: "Pilih",
    type: "Tipe",
    uploadImageVideo: "Unggah Gambar",
    user: "Pengguna",
    userName: "Nama Pengguna",
    usersSelected: "Pengguna Dipilih",
    topics: "Topik",
    date: "Tanggal",
    addNew: "TAMBAH BARU",
    exportAsCsv: "Ekspor sebagai CSV",
    noData: "Tidak Ada Data Ditemukan",
  
    dashboard: "Dasbor",
    mainDashboard: "Dasbor Utama",
    userDashboard: "Dasbor Pengguna",
    areYouSureText: "Apakah Anda yakin ingin melakukan tindakan ini?",
  
    tickets: {
      actions: {
        create: "Buat Tiket",
        delete: "Hapus Tiket",
        edit: "Edit Tiket",
      },
      areaOfRequest: "Area Permintaan",
      assignee: "Assignee",
      deleteTicket: {
        confirmation: "Apakah Anda yakin ingin menghapus tiket {0}?",
      },
      dueDate: "Tanggal Jatuh Tempo",
      filters: {
        ticketFor: "Tiket Untuk",
      },
      form: {
        ticketType: {
          admin: "Buat Tiket untuk Admin Dimitra",
          user: "Buat Tiket untuk Pengguna Aplikasi",
        },
      },
      markAsRead: "Tandai sebagai sudah dibaca",
      messages: {
        created: {
          success: "Tiket berhasil dibuat",
        },
        deleted: {
          success: "Tiket berhasil dihapus",
        },
      },
      noData: "Tidak Ada Tiket!",
      noDataHelpText:
        'Anda belum memiliki tiket yang ditugaskan kepada Anda. Klik tombol "Buat Tiket" di atas layar untuk memulai.',
      pickerInMenu: "Picker di menu",
      priority: {
        high: "Tinggi",
        label: "Prioritas",
      },
      reply: "Balas",
      requestedDateTime: "Tanggal dan Waktu Diminta",
      requestorDetails: "Detail Pemohon",
      requestorEmail: "Email Pemohon",
      subject: "Subjek",
      ticketsForItems: {
        all: "Semua",
        dimitraAdmin: "Admin Dimitra",
        multipleUsers: "Beberapa Pengguna",
        singleUser: "Satu Pengguna",
      },
      title: "Tiket",
    },
  
    months: "Bulan",
    days: "Hari",
    open: "Buka",
    closed: "Tutup",
    moreInfoRequired: "Informasi Lebih Lanjut Diperlukan",
    publicDueDiligenceReportSettings: "Pengaturan Laporan Uji Tuntas Publik",
    fieldRequired: "Kolom ini wajib diisi.",
    valueMustBeGreaterThanZero: "Nilai harus lebih besar dari nol.",
    valueExceedsLimit:
      "Waktu kedaluwarsa tidak boleh melebihi 12 bulan sesuai dengan peraturan EUDR.",
    valueMustBeInteger: "Nilai harus berupa angka bulat.",
    reset: "mengatur ulang",
    showingAll: "Menampilkan Semua",
    viewDeforestationDetails: "Lihat Detail Risiko Deforestasi",
  
    listOfShipments: "Daftar Pengiriman",
    viewShipment: "Lihat Pengiriman",
    shipmentCratedSuccess: "Pengiriman berhasil dibuat.",
    pleaseSelectAtLeastOneDueDeligenceReport:
      "Silakan pilih setidaknya satu laporan uji tuntas",
    confirmation: "Konfirmasi",
  
    confirmDialog: {
      assessmentBuilder: {
        delete: {
          title: "Hapus Penilaian",
          message: "Apakah Anda yakin ingin menghapus Penilaian?",
          confirmBtn: "Konfirmasi?",
        },
      },
      dueDiligenceReport: {
        delete: {
          title: "Hapus Laporan Uji Tuntas EUDR",
          message: "Apakah Anda yakin ingin menghapus Laporan Uji Tuntas EUDR?",
          confirmBtn: "Konfirmasi",
        },
      },
      farm: {
        delete: {
          title: "Hapus Peternakan",
          message: "Apakah Anda yakin ingin menghapus Peternakan?",
          confirmBtn: "Konfirmasi",
        },
      },
      status: {
        delete: {
          title: "Hapus Status Deforestasi",
          message: "Apakah Anda yakin ingin menghapus status deforestasi?",
          confirmBtn: "Konfirmasi",
        },
      },
    },
  
    timeAgo: {
      minute: "satu menit yang lalu",
      minutes: "{count} menit yang lalu",
      hour: "satu jam yang lalu",
      hours: "{count} jam yang lalu",
      day: "satu hari yang lalu",
      days: "{count} hari yang lalu",
      month: "satu bulan yang lalu",
      months: "{count} bulan yang lalu",
      year: "satu tahun yang lalu",
      years: "{count} tahun yang lalu",
    },
    pleaseAgreeToDeclaration: "Silakan setujui pernyataan untuk menyelesaikan.",
    importProductionPlaceTT:
      "Memungkinkan pengguna untuk mengimpor data tempat produksi menggunakan opsi unggah atau unduh file.",
    defaultCircularGeofence:
      "Peternakan tanpa geofence atau tanpa informasi tentang ukurannya akan diberi geofence melingkar default seluas 4 hektar. Jika ukuran rata-rata peternakan lebih kecil dari 4 hektar, harap ubah ukuran default dengan mengklik tombol 'Edit' di bawah.",
    accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon:
      "Menurut EUDR, peternakan dengan luas kurang dari 4 hektar tidak memerlukan poligon.",
    uploadOneDeforestationAssessmentForAllFarms:
      "UNGGAH SATU PENILAIAN DEFORESTASI UNTUK SEMUA PERTANIAN",
    uploadAssessment: "Unggah Penilaian",
    noUploadToBlockchain: "Tidak Ada Unggahan ke Blockchain",
    noDataForBlockchain:
      "Karena tidak ada laporan deforestasi yang dihasilkan untuk tempat produksi, tidak ada data untuk ditulis ke blockchain. Jika ini tidak terduga, pastikan bahwa laporan untuk pertanian telah dihasilkan dengan benar pada langkah sebelumnya.",
    seeDetails: "Lihat Detail",
  };
  